import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getTheme,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { isSourceImageVertical } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import { AppState } from '../../../types/store';
import { appLoaded, pathChange } from '../../actions/app';
import { isSectionLoading, getActiveSection } from '../../selectors/sections';
import { getCoverDeviation } from '../../selectors/deviations';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../selectors/users';
import { getIsRepositioning } from '../../selectors/profileHero';

import App, { Props } from './App';

type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'environment'
  | 'profileOwnerId'
  | 'theme'
  | 'hasVerticalCoverImage'
  | 'isMobile'
  | 'isOwner'
  | 'isSectionLoading'
  | 'isReducedHero'
  | 'showProfileEditAid'
  | 'showProfileHeroAid'
>;
type DispatchProps = Pick<Props, 'onAppRendered' | 'onPathChange'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getCoverDeviation(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const isHeroEditingActive = getIsRepositioning(state);
  return {
    activeSection: getActiveSection(state),
    isMobile: getIsMobile(state),
    isOwner,
    profileOwnerId: profileOwnerUser.userId,
    isSectionLoading: isSectionLoading(state),
    theme: getTheme(state),
    environment: state.environment.type,
    hasVerticalCoverImage: coverDeviation
      ? isSourceImageVertical(coverDeviation)
      : false,
    showProfileHeroAid:
      isOwner &&
      !coverDeviation &&
      hasFirstTimeFlag(state, FirstTimeFlag.ProfileHeroAidNotClosed),
    showProfileEditAid:
      isOwner &&
      hasFirstTimeFlag(state, FirstTimeFlag.ProfileEditAidNotClosed) &&
      !isHeroEditingActive,
    isReducedHero: flagEnabled(state, 'profile_reduced_hero'),
    isHeroEditingActive,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onAppRendered: appLoaded,
  onPathChange: pathChange,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
